let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("deOq3")).then(() => parcelRequire('8sEmV'));